/*
 *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
*****************************************************************************/
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _interopDefault(a) {
  return a && "object" === typeof a && "default" in a ? a["default"] : a;
}

var React = require("react"),
    React__default = _interopDefault(React),
    _extendStatics = function extendStatics(a, c) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (a, c) {
    a.__proto__ = c;
  } || function (a, c) {
    for (var d in c) {
      c.hasOwnProperty(d) && (a[d] = c[d]);
    }
  };

  return _extendStatics(a, c);
};

function __extends(a, c) {
  function f() {
    this.constructor = a;
  }

  _extendStatics(a, c);

  a.prototype = null === c ? Object.create(c) : (f.prototype = c.prototype, new f());
}

var _assign = function __assign() {
  _assign = Object.assign || function (a) {
    for (var c, f = 1, b = arguments.length; f < b; f++) {
      c = arguments[f];

      for (var d in c) {
        Object.prototype.hasOwnProperty.call(c, d) && (a[d] = c[d]);
      }
    }

    return a;
  };

  return _assign.apply(this, arguments);
};

function __rest(a, c) {
  var f = {},
      b;

  for (b in a) {
    Object.prototype.hasOwnProperty.call(a, b) && 0 > c.indexOf(b) && (f[b] = a[b]);
  }

  if (null != a && "function" === typeof Object.getOwnPropertySymbols) {
    var d = 0;

    for (b = Object.getOwnPropertySymbols(a); d < b.length; d++) {
      0 > c.indexOf(b[d]) && (f[b[d]] = a[b[d]]);
    }
  }

  return f;
}

function __awaiter(a, c, f, b) {
  return new (f || (f = Promise))(function (d, h) {
    function g(a) {
      try {
        k(b.next(a));
      } catch (l) {
        h(l);
      }
    }

    function e(a) {
      try {
        k(b["throw"](a));
      } catch (l) {
        h(l);
      }
    }

    function k(a) {
      a.done ? d(a.value) : new f(function (c) {
        c(a.value);
      }).then(g, e);
    }

    k((b = b.apply(a, c || [])).next());
  });
}

function __generator(a, c) {
  function f(a) {
    return function (c) {
      return b([a, c]);
    };
  }

  function b(b) {
    if (h) throw new TypeError("Generator is already executing.");

    for (; d;) {
      try {
        if (h = 1, g && (e = b[0] & 2 ? g["return"] : b[0] ? g["throw"] || ((e = g["return"]) && e.call(g), 0) : g.next) && !(e = e.call(g, b[1])).done) return e;
        if (g = 0, e) b = [b[0] & 2, e.value];

        switch (b[0]) {
          case 0:
          case 1:
            e = b;
            break;

          case 4:
            return d.label++, {
              value: b[1],
              done: !1
            };

          case 5:
            d.label++;
            g = b[1];
            b = [0];
            continue;

          case 7:
            b = d.ops.pop();
            d.trys.pop();
            continue;

          default:
            if (!(e = d.trys, e = 0 < e.length && e[e.length - 1]) && (6 === b[0] || 2 === b[0])) {
              d = 0;
              continue;
            }

            if (3 === b[0] && (!e || b[1] > e[0] && b[1] < e[3])) d.label = b[1];else if (6 === b[0] && d.label < e[1]) d.label = e[1], e = b;else if (e && d.label < e[2]) d.label = e[2], d.ops.push(b);else {
              e[2] && d.ops.pop();
              d.trys.pop();
              continue;
            }
        }

        b = c.call(a, d);
      } catch (l) {
        b = [6, l], g = 0;
      } finally {
        h = e = 0;
      }
    }

    if (b[0] & 5) throw b[1];
    return {
      value: b[0] ? b[1] : void 0,
      done: !0
    };
  }

  var d = {
    label: 0,
    sent: function sent() {
      if (e[0] & 1) throw e[1];
      return e[1];
    },
    trys: [],
    ops: []
  },
      h,
      g,
      e,
      k;
  return k = {
    next: f(0),
    "throw": f(1),
    "return": f(2)
  }, "function" === typeof Symbol && (k[Symbol.iterator] = function () {
    return this;
  }), k;
}

var convertActionToBase64 = function convertActionToBase64(a) {
  return Buffer.from(JSON.stringify(a)).toString("base64");
},
    createCache = function createCache(a, c) {
  var f = {},
      b = function b(a) {
    delete f[convertActionToBase64(a)];
  };

  return {
    add: function add(b, c) {
      a(b) && (f[convertActionToBase64(b)] = _assign(_assign({}, c), {
        timestamp: Date.now()
      }));
    },
    get: function get(a) {
      var d = f[convertActionToBase64(a)],
          g = d && c(d);
      if (g) return d;
      d && !g && b(a);
    },
    getItems: function getItems() {
      return f;
    },
    remove: b,
    setItems: function setItems(a) {
      f = a;
    }
  };
},
    QueryError = function (a) {
  function c(f, b) {
    f = a.call(this, f) || this;
    Object.setPrototypeOf(f, c.prototype);
    f.name = "QueryError";
    f.response = b;
    return f;
  }

  __extends(c, a);

  return c;
}(Error),
    createClient = function createClient(a) {
  void 0 === a && (a = {});

  var c = a.cacheProvider,
      f = createCache(function () {
    return !0;
  }, function () {
    return !0;
  }),
      b = function b(a, c) {
    return __awaiter(void 0, void 0, void 0, function () {
      var f, d, e, g;
      return __generator(this, function (l) {
        switch (l.label) {
          case 0:
            f = c[0];
            d = c.slice(1);
            if (!f) return [3, 3];
            g = b;
            return [4, f(h)(a)];

          case 1:
            return [4, g.apply(void 0, [l.sent(), d])];

          case 2:
            return e = l.sent(), [3, 4];

          case 3:
            e = a, l.label = 4;

          case 4:
            return [2, e];
        }
      });
    });
  },
      d = function d(a, c, b) {
    return __awaiter(void 0, void 0, void 0, function () {
      var f, e, g, k, m;
      return __generator(this, function (l) {
        switch (l.label) {
          case 0:
            f = b[0];
            e = b.slice(1);
            if (!f) return [3, 3];
            k = d;
            m = [a];
            return [4, f(h)(a, c)];

          case 1:
            return [4, k.apply(void 0, m.concat([l.sent(), e]))];

          case 2:
            return g = l.sent(), [3, 4];

          case 3:
            g = c, l.label = 4;

          case 4:
            return [2, g];
        }
      });
    });
  },
      h = {
    cache: c,
    query: function query(f, e) {
      void 0 === e && (e = !1);
      return __awaiter(void 0, void 0, void 0, function () {
        var g, h, l, r, u, m, n, t, x, p, q, y, z, v, A;
        return __generator(this, function (k) {
          switch (k.label) {
            case 0:
              return k.trys.push([0, 5,, 6]), [4, b(f, a.requestInterceptors || [])];

            case 1:
              g = k.sent();
              h = g.endpoint;
              l = g.body;
              r = g.responseType;
              u = __rest(g, ["endpoint", "body", "responseType"]);
              if (c && !e && (m = c.get(f))) return [2, m];
              n = u.headers;
              l && (l instanceof FormData || l instanceof Blob || l instanceof ArrayBuffer) || (n = _assign({
                "Content-Type": "application/json; charset=utf-8"
              }, u.headers));
              t = n && n["Content-Type"] && -1 !== n["Content-Type"].indexOf("json");
              x = a.fetch || fetch;
              return [4, x(h, _assign(_assign({}, u), {
                body: l ? t ? JSON.stringify(l) : l : void 0,
                headers: n,
                responseType: r
              }))];

            case 2:
              return p = k.sent(), y = d, z = [g], v = {
                error: !p.ok,
                headers: p.headers
              }, [4, resolveResponse(p, r)];

            case 3:
              return [4, y.apply(void 0, z.concat([(v.payload = k.sent(), v.status = p.status, v), a.responseInterceptors || []]))];

            case 4:
              q = k.sent();
              c && p.ok && c.add(f, q);
              if (q.status && g.config && g.config.emitErrorForStatuses && g.config.emitErrorForStatuses.includes(q.status)) throw new QueryError("request-error", q);
              return [2, q];

            case 5:
              return A = k.sent(), [2, {
                error: !0,
                errorObject: A
              }];

            case 6:
              return [2];
          }
        });
      });
    },
    suspenseCache: f
  };

  return h;
};

function resolveResponse(a, c) {
  return __awaiter(this, void 0, void 0, function () {
    var f, b, d, h;
    return __generator(this, function (g) {
      switch (g.label) {
        case 0:
          return c ? [2, a[c]()] : [3, 1];

        case 1:
          return f = [204, 205], b = a.headers.get("Content-Type"), (d = -1 === f.indexOf(a.status) && b && -1 !== b.indexOf("json")) ? [4, a.json()] : [3, 3];

        case 2:
          return h = g.sent(), [3, 5];

        case 3:
          return [4, a.text()];

        case 4:
          h = g.sent(), g.label = 5;

        case 5:
          return [2, h];
      }
    });
  });
}

var initialContext = {
  query: function query() {
    console.warn("Add ClientProvider to use client context");
    return Promise.resolve({
      error: !0,
      status: 0
    });
  },
  suspenseCache: createCache(function () {
    return !0;
  }, function () {
    return !0;
  })
},
    ClientContext = React.createContext(initialContext),
    SET_LOADING = "response/loading",
    RESET_LOADING = "response/reset-loading",
    RESET = "response/reset",
    SET_RESPONSE = "response/set",
    responseReducer = function responseReducer(a, c) {
  switch (c.type) {
    case SET_LOADING:
      return _assign(_assign({}, a), {
        loading: !0
      });

    case RESET_LOADING:
      return _assign(_assign({}, a), {
        loading: !1
      });

    case SET_RESPONSE:
      if (!c.response) throw Error();
      return _assign(_assign({}, a), {
        loading: !1,
        response: c.response
      });

    case RESET:
      return {
        loading: !1,
        response: {
          error: !1
        }
      };

    default:
      throw Error();
  }
},
    useCachedResponse = function useCachedResponse(a) {
  var c = React.useContext(ClientContext);
  if (c.cache) return c.cache.get(a);
},
    useQuery = function useQuery(a, c) {
  void 0 === c && (c = !0);
  var f = React.useContext(ClientContext),
      b = useCachedResponse(a),
      d = React.useRef(!0),
      h = React.useRef(),
      g = React.useReducer(responseReducer, {
    loading: b ? !1 : c,
    response: b ? b : {
      error: !1
    }
  }),
      e = g[0],
      k = g[1];
  React.useEffect(function () {
    d.current = !0;
    c && !b && w();
    return function () {
      d.current = !1;
      l();
    };
  }, [convertActionToBase64(a)]);
  var w = React.useCallback(function (c) {
    void 0 === c && (c = !1);
    return __awaiter(void 0, void 0, void 0, function () {
      var b, g, e;
      return __generator(this, function (l) {
        switch (l.label) {
          case 0:
            b = "AbortController" in window ? new AbortController() : void 0;
            g = a.signal || (b ? b.signal : void 0);
            h.current && h.current.abort();
            h.current = b;
            if (!d.current) return [2, {
              error: !1
            }];
            k({
              type: SET_LOADING
            });
            return [4, f.query(_assign(_assign({}, a), {
              signal: a.signal || g
            }), c)];

          case 1:
            return e = l.sent(), !d.current || e.errorObject && "AbortError" === e.errorObject.name || k({
              type: SET_RESPONSE,
              response: e
            }), d.current && e.errorObject && "AbortError" === e.errorObject.name && h.current && h.current === b && (h.current = void 0, k({
              type: RESET_LOADING
            })), [2, e];
        }
      });
    });
  }, [convertActionToBase64(a), f.query]);
  g = React.useCallback(function () {
    return w(!0);
  }, [w]);
  var l = React.useCallback(function () {
    h.current && h.current.abort();
  }, []),
      r = React.useCallback(function () {
    k({
      type: RESET
    });
  }, []);
  if (e.response && e.response.errorObject && e.response.errorObject instanceof QueryError) throw e.response.errorObject;
  return _assign({
    abort: l,
    loading: e.loading,
    query: g,
    reset: r
  }, e.response);
},
    useMutation = function useMutation(a) {
  var c = React.useContext(ClientContext),
      f = React.useRef(!0),
      b = React.useRef(),
      d = React.useReducer(responseReducer, {
    loading: !1,
    response: {
      error: !1
    }
  }),
      h = d[0],
      g = d[1];
  React.useEffect(function () {
    f.current = !0;
    return function () {
      f.current = !1;
      e();
    };
  }, []);
  d = React.useCallback(function () {
    for (var e = [], d = 0; d < arguments.length; d++) {
      e[d] = arguments[d];
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var d, h, l, k;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            if (!f.current) return [2, {
              error: !1
            }];
            d = a.apply(void 0, e);
            h = "AbortController" in window ? new AbortController() : void 0;
            l = d.signal || (h ? h.signal : void 0);
            b.current && b.current.abort();
            b.current = h;
            g({
              type: SET_LOADING
            });
            return [4, c.query(_assign(_assign({}, d), {
              signal: d.signal || l
            }))];

          case 1:
            return k = t.sent(), !f.current || k.errorObject && "AbortError" === k.errorObject.name || g({
              type: SET_RESPONSE,
              response: k
            }), f.current && k.errorObject && "AbortError" === k.errorObject.name && b.current && b.current === h && (b.current = void 0, g({
              type: RESET_LOADING
            })), [2, k];
        }
      });
    });
  }, [a, c.query]);
  var e = React.useCallback(function () {
    b.current && b.current.abort();
  }, []),
      k = React.useCallback(function () {
    g({
      type: RESET
    });
  }, []);
  if (h.response && h.response.errorObject && h.response.errorObject instanceof QueryError) throw h.response.errorObject;
  return _assign({
    abort: e,
    loading: h.loading,
    mutate: d,
    reset: k
  }, h.response);
},
    useBulkMutation = function useBulkMutation(a) {
  var c = React.useContext(ClientContext).query,
      f = React.useRef(!0),
      b = React.useRef(),
      d = React.useState({
    loading: !1,
    responses: []
  }),
      h = d[0],
      g = d[1],
      e = React.useCallback(function () {
    b.current && b.current.abort();
  }, [b]);
  React.useEffect(function () {
    f.current = !0;
    return function () {
      f.current = !1;
      e();
    };
  }, [e]);
  d = React.useCallback(function (d) {
    return __awaiter(void 0, void 0, void 0, function () {
      var e, h, k, m;
      return __generator(this, function (l) {
        switch (l.label) {
          case 0:
            if (!f.current) return [2, Array.from(Array(10).keys()).map(function () {
              return {
                error: !1
              };
            })];
            e = "AbortController" in window ? new AbortController() : void 0;
            h = d.map(function (b) {
              return a(b);
            });
            k = e ? e.signal : void 0;
            h.forEach(function (a) {
              return a.signal = a.signal || k;
            });
            b.current && b.current.abort();
            b.current = e;
            g(function (a) {
              return _assign(_assign({}, a), {
                loading: !0
              });
            });
            return [4, Promise.all(h.map(function (a) {
              return c(a);
            }))];

          case 1:
            return m = l.sent(), f.current && g({
              loading: !1,
              responses: m.map(function (a, c) {
                if (!a.errorObject || "AbortError" !== a.errorObject.name) return h[c].signal === k && b.current === e && (b.current = void 0, g(function (a) {
                  return _assign(_assign({}, a), {
                    loading: !1
                  });
                })), a;
              })
            }), [2, m];
        }
      });
    });
  }, [c, a]);
  var k = React.useCallback(function () {
    g({
      loading: !1,
      responses: []
    });
  }, [g]);
  return {
    abort: e,
    loading: h.loading,
    mutate: d,
    reset: k,
    responses: h.responses
  };
},
    useSuspenseQuery = function useSuspenseQuery(a) {
  var c = React.useContext(ClientContext),
      f = React.useState(null),
      b = f[0],
      d = f[1],
      h = c.suspenseCache.get(a);
  React.useEffect(function () {
    h && h.response && null !== b && c.suspenseCache.remove(a);
    return function () {
      c.suspenseCache.remove(a);
    };
  }, [convertActionToBase64(a)]);

  f = function f() {
    c.suspenseCache.remove(a);
    d(!b);
  };

  if (h) {
    if (h.response) {
      if (h.response.errorObject && h.response.errorObject instanceof QueryError) throw h.response.errorObject;
      return _assign(_assign({}, h.response), {
        query: f
      });
    }

    throw h.fetch;
  }

  var g = c.query(a, null !== b).then(function (b) {
    c.suspenseCache.add(a, {
      fetch: g,
      response: b
    });
  });
  c.suspenseCache.add(a, {
    fetch: g
  });
  throw g;
},
    useClient = function useClient() {
  return React.useContext(ClientContext);
},
    useParameterizedQuery = function useParameterizedQuery(a) {
  var c = useMutation(a);
  a = c.mutate;
  c = __rest(c, ["mutate"]);
  return _assign(_assign({}, c), {
    query: a
  });
},
    Query = function Query(a) {
  var c = a.children,
      f = a.initFetch;
  a = useQuery(a.action, void 0 === f ? !0 : f);
  return c(a);
},
    Mutation = function Mutation(a) {
  var c = a.children;
  a = useMutation(a.actionCreator);
  return c(a);
},
    SuspenseQuery = function SuspenseQuery(a) {
  var c = a.children;
  a = useSuspenseQuery(a.action);
  return c(a);
},
    QueryErrorBoundary = function (a) {
  function c(c) {
    var b = a.call(this, c) || this;
    b.state = {
      hasError: !1
    };

    b.restart = function () {
      b.setState({
        hasError: !1,
        response: void 0
      });
    };

    b.state = {
      hasError: !1,
      response: void 0
    };
    return b;
  }

  __extends(c, a);

  c.getDerivedStateFromError = function (a) {
    if (a instanceof QueryError) return {
      hasError: !0,
      response: a.response
    };
  };

  c.prototype.render = function () {
    return this.state.hasError && this.state.response && this.state.response.status && this.props.statuses.includes(this.state.response.status) ? this.props.fallback(this.state.response, this.restart) : this.props.children;
  };

  return c;
}(React.Component),
    ClientContextProvider = function ClientContextProvider(a) {
  var c = a.client;
  return React__default.createElement(ClientContext.Provider, {
    value: {
      query: c.query,
      cache: c.cache,
      suspenseCache: c.suspenseCache
    }
  }, a.children);
};

exports.ClientContext = ClientContext;
exports.ClientContextProvider = ClientContextProvider;
exports.Mutation = Mutation;
exports.Query = Query;
exports.QueryError = QueryError;
exports.QueryErrorBoundary = QueryErrorBoundary;
exports.SuspenseQuery = SuspenseQuery;
exports.convertActionToBase64 = convertActionToBase64;
exports.createCache = createCache;
exports.createClient = createClient;
exports.useBulkMutation = useBulkMutation;
exports.useCachedResponse = useCachedResponse;
exports.useClient = useClient;
exports.useMutation = useMutation;
exports.useParameterizedQuery = useParameterizedQuery;
exports.useQuery = useQuery;
exports.useSuspenseQuery = useSuspenseQuery;